'use strict';

import React, { Component } from 'react';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import Loader from 'Pure/Loader';
const styles = {
  height: '200px',
  width: '100%',
  position: 'relative'
};
const error_styles = {
  height: '200px',
  width: '100%',
  position: 'relative',
  paddingLeft: 20,
  paddingRight: 20
};
export default class IframeLoaderPage extends Component {
  state = {};
  render() {
    const is__error = document.location.pathname.endsWith('/ko');
    const output = /*#__PURE__*/React.createElement("div", {
      className: "front-page"
    }, /*#__PURE__*/React.createElement("div", {
      style: is__error ? error_styles : styles
    }, is__error ? getFormStatus({
      error: 'Échec du paiement.'
    }, ['v2']) : /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['primary', 'bg-white', 'medium'],
      text: "Chargement..."
    })));
    return output;
  }
}
